import SarcopeniaMeasureStore from "./SarcopeniaMeasureStore";
import PanelControlStore from "./panelControlStore";
import AuthStore from "./authStore";
import Store from ".";

/**
 * @class RootStore
 * @description 여럿 Store들을 연결
 */
export default class RootStore {
  sarcopeniaMeasureStore: SarcopeniaMeasureStore; /// Study 목록 정보 저장 Store
  panelControlStore: PanelControlStore;
  authStore: AuthStore;

  constructor() {
    this.sarcopeniaMeasureStore = new Store.SarcopeniaMeasureStore(this); /// Study 목록 정보를 저장하는 Store 연결
    this.panelControlStore = new Store.PanelControlStore(this); /// Study 목록 정보를 저장하는 Store 연결
    this.authStore = new Store.AuthStore(this);
  }
}
